export default "__VITE_ASSET__CMWQIOsu__"